import React from 'react';
import Spacing from '../Spacing';



export const Specification = ({Specifications}) => {
  const data = Specifications[0]; // Assuming we are displaying the first object in the array

  return (
    <div className="container">
          <h3 className="underline">{data.subheading}</h3>
      <div className="specification">
      
        <div className="leftside-specification">
          {[
            { title: data.DimensionsTitle, items: data.Dimensions },
            { title: data.PowerSupplyTitle, items: data.PowerSupply },
            { title: data.CompressorTitle, items: data.Compressor },
            { title: data.OutputPortsTitle, items: data.OutputPorts },
          ].map((section, index) => (
            <div key={index}>
              <h4  style={{
                fontSize:"16px"
              }}>{section.title}</h4>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="rightside-specification">
          {[
            { title: data.CoolingWaterTankTitle, items: data.CoolingWaterTank },
            { title: data.HeatingChamberTitle, items: data.HeatingChamber },
            { title: data.AutoCleaningTitle, items: data.AutoCleaning },
            { title: data.TemperatureRangeTitle, items: data.TemperatureRange },
          ].map((section, index) => (
            <div key={index}>
              <h4>{section.title}</h4>
              <ul>
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <Spacing md="32" />
    </div>
  );
};
